export enum OfferModificationCode {
    AC_VARIANT = 'AC_VARIANT',
    MINICASCO_VARIANT = 'MINICASCO_VARIANT',
    AC = 'AC',
    AC_TERRITORIAL_RANGE = 'AC_TERRITORIAL_RANGE',
    AC_EXCESS = 'AC_EXCESS',
    AC_EXCESS_THIEF = 'AC_EXCESS_THIEF',
    AC_GSU = 'AC_GSU',
    NNW = 'NNW',
    ASSISTANCE = 'ASSISTANCE',
    GLASS = 'GLASS',
    REPLACEMENT_CAR = 'REPLACEMENT_CAR',
    TIRES = 'TIRES',
    LUGGAGE = 'LUGGAGE',
    MEDIC = 'MEDIC',
    BATTERY = 'BATTERY',
    DIRECT_LOSS_SETTLEMENT = 'DIRECT_LOSS_SETTLEMENT',
    LEGAL_PROTECTION = 'LEGAL_PROTECTION',
    SPORTS_EQUIPMENT = 'SPORTS_EQUIPMENT',
    REPAIR_PARTS = 'REPAIR_PARTS',
    PARTS_DEPRECIATION = 'PARTS_DEPRECIATION',
    PRICE_LOSS = 'PRICE_LOSS',
    GREEN_CARD = 'GREEN_CARD',
    RENEWABLE_INSURANCE_AMOUNT = 'RENEWABLE_INSURANCE_AMOUNT',
}

export enum AcVariantsModificationOption {
    KOSZTORYS_BEZ_AMORTYZACJI = 'KOSZTORYS_BEZ_AMORTYZACJI',
    KOSZTORYS_Z_AMORTYZACJA = 'KOSZTORYS_Z_AMORTYZACJA',
    WARSZTAT = 'WARSZTAT',
    SERWIS_ASO = 'SERWIS_ASO',
    WARSZTAT_PLUS = 'WARSZTAT_PLUS',
}

export enum UniqaAssistanceCoverage {
    NONE = 'NONE',
    STANDARD = 'STANDARD',
    STANDARD_PLUS = 'STANDARD_PLUS',
    PREMIUM = 'PREMIUM',
    PRESTIGE = 'PRESTIGE',
}

export enum PevnoAssistanceCoverage {
    MAXIMUM = 'MAXIMUM',
    EXPANDED = 'EXPANDED',
    ECONOMIC = 'ECONOMIC',
    NONE = 'NONE',
}

export type AssistanceCoverage = UniqaAssistanceCoverage | PevnoAssistanceCoverage;
